export default "__VITE_ASSET__CMb$64Zm__"